export default __webpack_public_path__ + "static/media/7-10_icon.7838d8f4.svg";